module.exports = __webpack_public_path__ + "img/07.e1e9eab8.png";